module.exports = __webpack_public_path__ + "static/media/astella_logo_white.3f4980e3.png";